import { createFileRoute } from "@tanstack/react-router";
import { getGetAppDataWithParamsQueryOptions } from "src/util/query_client";
import LoadingOverlay from "src/components/LoadingOverlay";
import { getAppDataGetAppDataQueryOptions } from "@/model/app-data";
import { useSuspenseQuery } from "@tanstack/react-query";
import { getListJournalEntriesQueryOptions } from "@/model_v2/journal";
import TradingJournal from "@/components/Journal";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { normalizeTrades } from "@/util/unifiedTradesApi";
import { AppDataResponse } from "@/model/client.schemas";

export const Route = createFileRoute("/_app/journal")({
  component: JournalPage,
  staticData: {
    title: "Journal",
  },
  pendingComponent: () => <LoadingOverlay isLoading={true} />,
});

function JournalPage() {
  const useV2Api = useFeatureFlag("use_v2_imports");

  const journalQuery = getListJournalEntriesQueryOptions();

  // Choose query options based on feature flag
  // Journal doesn't need attributes - uses compact response
  const tradesQuery = useV2Api
    ? getGetAppDataWithParamsQueryOptions()
    : getAppDataGetAppDataQueryOptions();

  // @ts-ignore - Tanstack Query v5 types seem off here
  const { data: tradesResponse } = useSuspenseQuery(tradesQuery);
  // @ts-ignore - Tanstack Query v5 types seem off here
  const { data: journalEntriesResponse } = useSuspenseQuery(journalQuery);

  // Normalize trades from either API version
  // Cast to AppDataResponse since we're normalizing the data
  const normalizedAppData = {
    ...tradesResponse.data,
    all_trades: normalizeTrades(tradesResponse?.data.all_trades),
  } as AppDataResponse;

  return (
    <div className="h-full">
      <TradingJournal
        app_data={normalizedAppData}
        journals={journalEntriesResponse}
      />
    </div>
  );
}
